module.exports = __webpack_public_path__ + "img/mask-group-22@1xcopy.1274deae.png";